"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findImageByType = findImageByType;
exports.resolveImageUrls = resolveImageUrls;
function findImageByType(images, type) {
    return images?.find((img) => img.type === type);
}
function resolveImageUrls(imageUrls, baseUrl) {
    const resolved = {};
    for (const [key, value] of Object.entries(imageUrls)) {
        if (value) {
            resolved[key] = `${baseUrl}/${value}`;
        }
    }
    return resolved;
}
